export function footerNavigation() {
    if (window.innerWidth < 768) {
        const footerNav = $(".footer-nav");
        const expandBtn = footerNav.find("strong");
        expandBtn.on("click", function () {
            $(this).parents(".nav-block").toggleClass("active").siblings(":not(.upper)").removeClass("active");
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/footerNavigation.js